import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const ModalTitle = styled.h3`
  margin-bottom: 1rem;
`;

export const ModalText = styled.p`
  margin-bottom: 0.5rem;
`;

export const ModalButton = styled.button`
  margin-top: 1.5rem;
  padding: ${({ theme }) => theme.form.inputPadding};
  background-color: ${({ theme }) => theme.colors.backgroundReverse};
  color: ${({ theme }) => theme.colors.textReverse};
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
